import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Navbar } from "./Navbar";
import Features from "./Features";
import Prices from "./Prices";
import Carousel from "./Carsoul";
import Cookies from "js-cookie";
function Home() {
  const navigate = useNavigate();


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const token = Cookies.get('access_token');
    if (token) {
      navigate('/home');
    }
  }, [navigate]);
  

  const uploadPage = () => {
    // Standard path requires an account — send to sign-in (Google/GitHub/email)
    // first, then continue to upload. (Lightning Fast stays no-login.)
    const token = Cookies.get('access_token');
    if (token) {
      navigate("/upload");
    } else {
      navigate("/signin", { state: { next: "/upload" } });
    }
  };

  const expressPage = () => {
    navigate("/express");
  };

  // Function to generate animated background circles
  const renderDynamicCircles = () => {
    return [...Array(10)].map((_, index) => {
      const size = Math.random() * 40 + 20; // Random size between 20 and 60px
      const top = Math.random() * 100; // Random top position
      const left = Math.random() * 100; // Random left position
      return (
        <motion.div
          key={index}
          className="absolute rounded-full bg-white opacity-40"
          style={{
            width: `${size}px`,
            height: `${size}px`,
            top: `${top}%`,
            left: `${left}%`,
          }}
          animate={{
            y: ["0%", "100%", "0%"],
            x: ["0%", "10%", "-10%"],
          }}
          transition={{
            duration: Math.random() * 5 + 5,
            repeat: Infinity,
            ease: "easeInOut",
            delay: Math.random() * 5,
          }}
        />
      );
    });
  };

  return (
    <><Navbar />
    <div className="relative mx-auto bg-gradient-to-b sm:pt-10 from-sky-300/30 to-white-300 min-h-screen px-6 sm:px-16 overflow-hidden">
      {/* Animated Background */}
      <motion.div
        className="absolute top-10 left-10 w-24 h-24 rounded-full bg-blue-400 opacity-20"
        animate={{
          x: [0, 30, -30, 0],
          y: [0, -30, 30, 0],
        }}
        transition={{ duration: 10, repeat: Infinity, ease: "easeInOut" }}
      ></motion.div>
      <motion.div
        className="absolute bottom-20 right-20 w-32 h-32 rounded-full bg-pink-400 opacity-20"
        animate={{
          x: [0, -40, 40, 0],
          y: [0, 40, -40, 0],
        }}
        transition={{ duration: 12, repeat: Infinity, ease: "easeInOut" }}
      ></motion.div>
      {renderDynamicCircles()}

      {/* Main Content */}
      <div className="flex flex-col sm:flex-row items-center justify-between pt-10 sm:pt-0">
        {/* Left Section */}
        <motion.div
          className="w-full sm:w-1/2 text-center text-black"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
        >
          <div className="flex flex-col space-y-4">
            <motion.h1
              className="text-2xl sm:text-4xl font-bold"
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1.2, delay: 0.3 }}
            >
              Get your resume job-ready in minutes and advance your career
            </motion.h1>
            <motion.p
              className="text-gray-700"
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1.2, delay: 0.5 }}
            >
              Unlock your career potential with our intuitive resume recommendations
            </motion.p>
            <div className="flex flex-col items-center space-y-4" onClick={uploadPage}>
              <div className="flex items-center space-x-4">
                <motion.div
                  className="w-20 h-[1px] bg-gray-300"
                  initial={{ scaleX: 0 }}
                  animate={{ scaleX: 1 }}
                  transition={{ duration: 1, delay: 0.7 }}
                ></motion.div>
                <motion.h2
                  className="text-lg font-semibold text-gray-800"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 1, delay: 0.9 }}
                >
                  Get Started
                </motion.h2>
                <motion.div
                  className="w-20 h-[1px] bg-gray-300"
                  initial={{ scaleX: 0 }}
                  animate={{ scaleX: 1 }}
                  transition={{ duration: 1, delay: 0.7 }}
                ></motion.div>
              </div>
              <motion.button
                className="bg-gray-800 text-white px-6 py-2 rounded-md text-lg flex items-center space-x-2 hover:bg-gray-700 transition"
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                whileHover={{ scale: 1.1 }}
                transition={{ duration: 0.8, delay: 1 }}
              >
                <span>Fit my resume</span>
                <span>🚀</span>
              </motion.button>
            </div>

            {/* ⚡ Lightning Fast — separate, no-login express path */}
            <motion.div
              className="mt-6 flex flex-col items-center"
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 1.2 }}
            >
              <button
                onClick={expressPage}
                className="flex items-center gap-2 bg-amber-500 text-white px-6 py-2.5 rounded-xl text-base font-semibold hover:bg-amber-400 transition shadow-md"
              >
                ⚡ Lightning Fast Resume
              </button>
              <span className="text-xs text-gray-500 mt-2">No sign-up — upload, pay once, download in minutes</span>
            </motion.div>
          </div>
        </motion.div>

        {/* Right Section */}
        <motion.div
          className="w-full sm:w-1/2 sm:pl-32"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
        >
          <motion.img
            src="https://res.cloudinary.com/danm2mfq5/image/upload/v1736142954/dhdi3qybgflfzpq4yzlp.png"
            alt="Resume Illustration"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 1.2, delay: 0.5 }}
          />
        </motion.div>
      </div>

      {/* Call to Action */}
      <motion.div
        className="mt-10 text-center"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.5, delay: 1.5 }}
      >
        <h2 className="text-xl font-semibold text-gray-800">
          Ready to boost your career prospects?
        </h2>
      </motion.div>
      <Carousel />
      {/* Features and Prices */}
      <Features />
      <Prices />
    </div>
    </>
  );
}

export default Home;
